import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';

const SubjectViewDialog = (props) => {
    const [dialogVisible, setDialogVisible] = useState(false);
    const toast = useRef(null);

    useEffect(() => {
        setDialogVisible(props.visible);
    }, [props]);

    useEffect(() => {
        setDialogVisible(props.visible);
    }, [props.visible]);

    const hideSubjectDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        setDialogVisible(false);
    };

    const subjectDialogFooter = (
        <>
            <Button label={translatedMessage('generic.close')} icon="pi pi-times" className="p-button-text" onClick={hideSubjectDialog} />
        </>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={dialogVisible}
                // style={{ width: '850px' }}
                header={translatedMessage('subject.details')}
                modal
                className="pcn-dialog p-fluid"
                footer={subjectDialogFooter}
                onHide={hideSubjectDialog}
            >
                <div className="grid">
                    <div className="col-2">{translatedMessage('generic.name')}</div>
                    <div className="col-10">{props.value?.name}</div>
                    <div className="col-2">{translatedMessage('subject.score')}</div>
                    <div className="col-10">{props.value?.score}</div>
                    <div className="col-2">{translatedMessage('subject.proposalsNo')}</div>
                    <div className="col-10">{props.value?.proposals?.length}</div>
                    <div className="col-12">
                        <DataTable value={props.value?.bibliography} selectionPageOnly={true} dataKey="id" responsiveLayout="scroll" className="mt-3">
                            <Column field="competitionBibliography.bibliography" header={translatedMessage('subject.bibliography')} />
                            <Column field="competitionBibliography.topic" header={translatedMessage('subject.bibliography.topic')} />
                        </DataTable>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default SubjectViewDialog;
